/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ groups: NonNullable<unknown> }} Assistant_Restore_LockedInputs */



/**
* | output |
* | --- |
* | "Locked groups keep their current content: {groups}." |
*
* @param {Assistant_Restore_LockedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_restore_locked = /** @type {((inputs: Assistant_Restore_LockedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Restore_LockedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Les groupes verrouillés conservent leur contenu actuel : ${i?.groups}.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Gesperrte Gruppen behalten ihren aktuellen Inhalt: ${i?.groups}.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`I gruppi bloccati mantengono il loro contenuto attuale: ${i?.groups}.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Заблокированные группы сохраняют свой текущий контент: ${i?.groups}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Los grupos bloqueados conservan su contenido actual: ${i?.groups}.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`锁定群组保留其当前内容：${i?.groups}。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ロックされたグループは現在のコンテンツを保持します: ${i?.groups}。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`लॉक किए गए समूह अपनी वर्तमान सामग्री बनाए रखते हैं: ${i?.groups}.`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Os grupos bloqueados mantêm seu conteúdo atual: ${i?.groups}.`)
	return /** @type {LocalizedString} */ (`Locked groups keep their current content: ${i?.groups}.`)
});